// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__Udb4z","background":"Layout_background__btwik","main":"Layout_main__mIuK3"};